import { render, staticRenderFns } from "./RevisedStipulationModal.vue?vue&type=template&id=3da3d5d3&"
import script from "./RevisedStipulationModal.vue?vue&type=script&lang=js&"
export * from "./RevisedStipulationModal.vue?vue&type=script&lang=js&"
import style0 from "./RevisedStipulationModal.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports